<template>
  <v-card flat>
    <v-card-title class="pa-0">
      <template class="text-left">
        <v-btn fab icon :color="showBack ? 'rgba(0, 0, 0, 0.54)' : 'transparent'" @click="$router.go(-1)" small>
          <v-icon>{{ showBack ? 'mdi-arrow-left-bold' : 'mdi-blank' }}</v-icon>
        </v-btn>
      </template>
      <v-img class="image-auto-size mr-4" @click="navigateToDashboard" width="25" height="25" contain :src="require('@/../public/img/logo.png')"></v-img>
      <template class="text-right">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-chip class="ma-2" v-on="on" label>
              <v-avatar left>
                <v-icon>mdi-account</v-icon>
              </v-avatar>
              <v-list-item-content class="username-css mx-1">
                <v-list-item-title>
                  {{ getuserDetails.name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() }}
                </v-list-item-title>
              </v-list-item-content>
            </v-chip>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in menuItems" :key="index" @click="menuActions(item.click, item.value)">
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item>
          </v-list>
       </v-menu>
      </template>
    </v-card-title>
    <!-- DELETE WARNING -->
    <v-dialog v-model="showDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.deleteConfirm') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.common.areYouSure') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="deleteConfirm" :loading="loading" @click="confirmDelete">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="primary" id="deleteClose" @click="showDialog=false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      drawer: true,
      listName: '',
      loading: false,
      on: true,
      activeUser: {}
    }
  },
  computed: {
    ...mapGetters(['showDialog', 'getuserDetails', 'deletePayload']),
    showDialog: {
      get () {
        return this.$store.getters.showDialog
      },
      set (val) {
        if (!val) this.$store.commit('hideDialog')
      }
    },
    getURL () {
      let url = process.env.VUE_APP_URL
      return url.split('/api')[0]
    },
    menuItems () {
      let language
      if (this.$i18n.locale === 'en') {
        language = { title: 'message.common.norwegian', value: 'no', click: 'language' }
      } else if (this.$i18n.locale === 'no') language = { title: 'message.common.english', value: 'en', click: 'language' }
      const items = [language, { title: 'message.layout.logout', click: 'logout' }]
      return items
    },
    showBack () {
      return this.$route.path !== '/dashboard'
    }
  },
  methods: {
    confirmDelete () {
      this.loading = true
      let model = this.deletePayload
      let dispatchAction = model.isSingle ? 'deleteSingleRecordHandler' : 'deleteHandler'
      this.$store.dispatch(dispatchAction, model)
        .then(() => {
          this.$eventBus.$emit('deleteSuccess', model.module)
        }).finally(() => {
          this.loading = false
        })
    },
    menuActions (action, value) {
      switch (action) {
        case 'logout':
          this.$store.dispatch('logout')
          this.$router.push('/login')
          break
        case 'language':
          this.changeLang(value)
          break
        default:
          break
      }
    },
    changeLang (language) {
      this.$i18n.locale = language
    },
    navigateToDashboard () {
      if (this.$route.path !== '/dashboard') this.$router.push('/dashboard')
    }
  }
}
</script>
<style lang="scss">
  @import '../assets/css/variables.scss';
  .image-auto-size .v-image__image--cover {
    background-size: auto !important;
  }
  .max-width-30-per {
    max-width: 30%;
  }
  .v-list .v-list-item--active {
    color: $layout-color !important;
  }
</style>
